import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReplay = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11 6C11 5.44772 11.4477 5 12 5C16.4183 5 20 8.58172 20 13C20 17.4183 16.4183 21 12 21C7.58172 21 4 17.4183 4 13C4 12.4477 4.44772 12 5 12C5.55228 12 6 12.4477 6 13C6 16.3137 8.68629 19 12 19C15.3137 19 18 16.3137 18 13C18 9.68629 15.3137 7 12 7C11.4477 7 11 6.55228 11 6Z",
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 5.73703C12 4.09201 12 3.2695 11.4719 2.98684C10.9437 2.70419 10.2593 3.16044 8.8906 4.07293L8.49615 4.3359C7.36723 5.08851 6.80278 5.46482 6.80278 6C6.80278 6.53518 7.36723 6.91149 8.49615 7.6641L8.8906 7.92707C10.2593 8.83956 10.9437 9.29581 11.4719 9.01316C12 8.7305 12 7.90799 12 6.26297V5.73703Z",
		fill: "black"
	})]
});
const ForwardRef = forwardRef(SvgReplay);
export { ForwardRef as ReactComponent };
